import { createSlice } from "@reduxjs/toolkit";

import ReturnAuthorizationModel from "models/ReturnAuthorizationModel";
import { initialResultsDtoModel, ResultsDtoModel } from 'models/ResultsDtoModel';

import { getReturns } from "services/return.service";

import { RootState } from "store/store";

interface ReturnState {
    returnsDto: ResultsDtoModel<ReturnAuthorizationModel>;
    loading: boolean;
    error?: string | null;
}

const initialState: ReturnState = {
    returnsDto: initialResultsDtoModel,
    loading: false,
    error: null
}

const demoReturn: ReturnAuthorizationModel[] = [
    {
        "rmaNumber": "BCDRMA003718",
        "creditMemoId": 23,
        "shipDate": new Date(),
        "serialNumbers": "BCD4458",
        "shipper": "",
        "creditMemo": "",
        "transactionId": 62338746,
        "purchaseOrder": "500386256385",
        "fileId": 1,
        "transactionDate": new Date(),
        "status": "Pending Receipt"
    },
    {
        "rmaNumber": "BCDRMA003713",
        "creditMemoId": 52,
        "shipDate": new Date(),
        "serialNumbers": "BCD1234",
        "shipper": "",
        "creditMemo": "",
        "transactionId": 62247149,
        "purchaseOrder": "500370544799",
        "fileId": 2,
        "transactionDate": new Date(),
        "status": "Pending Refund"
    },
    {
        "rmaNumber": "BCDRMA003715",
        "creditMemoId": 62382422,
        "shipDate": new Date(),
        "serialNumbers": "45BRY24",
        "shipper": "",
        "creditMemo": "CM002787567",
        "transactionId": 62212318,
        "purchaseOrder": "500505066252",
        "fileId": 3,
        "transactionDate": new Date(),
        "status": "Refunded"
    }
]

export const returnsSlice = createSlice({
    name: "returns",
    initialState,
    reducers: {
        clearReturns: (state) => {
            state.returnsDto = initialResultsDtoModel;
        },
        setDemoReturn: (state) => {
            state.returnsDto.items = demoReturn
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(getReturns.fulfilled, (state, action) => {
                state.returnsDto = action.payload;
                state.loading = false;
                state.error = null;
            })
            .addCase(getReturns.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(getReturns.rejected, (state, action) => {
                state.loading = false;
                state.error = action.error.message || 'Failed to load returns';
            })
    }
});

export const selectReturnsDto = (state: RootState) => state.returns.returnsDto;
export const returnsReducer = returnsSlice.reducer;
export const { clearReturns, setDemoReturn } = returnsSlice.actions;